import PropTypes from "prop-types";
import Button from "@/components/common/Button";

const ActionButtons = ({ onDelete, onModify }) => (
  <div className="flex gap-4">
    <Button
      text="DELETE"
      onClick={onDelete}
      customBgColor="white"
      customTextColor="primary"
      className="h-[34px] flex-1 border border-primary hover:bg-white"
    />
    <Button
      text="MODIFY"
      onClick={onModify}
      className="h-[34px] flex-1"
      customBgColor="primary"
      customTextColor="white"
      isActive={true}
      color="primary"
    />
  </div>
);

ActionButtons.propTypes = {
  onDelete: PropTypes.func,
  onModify: PropTypes.func,
};

export default ActionButtons;
